import React, { useState, useEffect, useRef } from "react";
import { Box, Snackbar, CircularProgress } from "@mui/material";
import EditIcon from "../../assets/images/editIcon.svg";
import DeleteIcon from "../../assets/images/DeleteIcon.svg";
import AddEditUser from "./AddEditUser";
import AccessibleTooltip from "../Tooltip/Tooltip.js";
import SubHeader from "../SubHeader";
import DeleteModal from "./DeleteModal";
import Table from "../Table";
import { useDispatch, useSelector } from "react-redux";
import {
  getAccessRights,
  processRows,
  fetchUsers,
  handleDeleteUser,
  resetDelete,
  getUserColumns,
} from "../../utils/mangeUserUtils.js";
import "./mustyle.scss";
import "../../assets/styles/glButton.scss";

const MangeUser = () => {
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const [hasData, setHasData] = useState(true);
  const [selectedEditId, setSelectedEditid] = useState();
  const [filters, setFilters] = useState({ searchTerm: "", role: "", status: "" });
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [actionButton, setActionButton] = useState("");
  const [editData, setEditData] = useState(null);
  const [deviceIdToDelete, setDeviceIdToDelete] = useState(null);

  const users = useSelector((state) => state.userList);
  const dispatch = useDispatch();
  const createUserBtnRef = useRef(null);
  const { edit, delete: canDelete, create } = getAccessRights();

  const handleEdit = (deviceData, selectedEditId) => {
    setSelectedEditid(selectedEditId);
    setEditData(deviceData.row);
    setActionButton("edit");
    setOpen(true);
  };

  const columns = getUserColumns({
    edit,
    canDelete,
    handleEdit,
    setOpenDeleteModal,
    setDeviceIdToDelete,
  });

  useEffect(() => {
    fetchUsers(dispatch);
  }, [dispatch]);

  useEffect(() => {
    if (!users.isLoading && users.data !== null) {
      setRows(users.data);
    }
  }, [users]);

  const processedRows = processRows(rows, filters);

  useEffect(() => {
    if (createUserBtnRef.current) {
      createUserBtnRef.current.focus();
    }
  }, []);

  return (
    <>
      <span className="sr-only" role="status" aria-live="polite">
        {!hasData
          ? "No data available"
          : `${processedRows.length} item${processedRows.length > 1 ? "s" : ""} found`}
      </span>

      <main className="main_ele_wrapper userMangement_wrapper" role="main">
        <SubHeader
          heading="User Management"
          headerButton={
            create && (
              <div
                className="AddUser new-entry"
                data-testid="add-user-button-wrapper-Desktop"
              >
                <button
                  ref={createUserBtnRef}
                  id="create-new-user-btn"
                  name="Create-New-User"
                  className="addDevice"
                  onClick={() => {
                    setOpen(true);
                    setActionButton("add");
                  }}
                  aria-label="Create new user"
                >
                  Create New User
                </button>
              </div>
            )
          }
        />

        <div className="new-EntryForMobile">
          {create && (
            <div
              className="AddUser new-entry"
              data-testid="add-user-button-wrapper"
            >
              <button
                id="create-new-user-btn"
                name="Create-New-User"
                className="containedButton"
                onClick={() => {
                  setOpen(true);
                  setActionButton("add");
                }}
                aria-label="Create new user"
              >
                Create New User
              </button>
            </div>
          )}
        </div>

        <div className="inner_Wrapper">
          <div className="floorMangementTable_wrapper manageUserTable_wrapper">
            {users.isLoading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <CircularProgress aria-label="Loading user data" />
              </Box>
            ) : (
              <Box sx={{ height: "auto", width: "100%" }}>
                <Table columns={columns} rows={processedRows} setHasData={setHasData} />
              </Box>
            )}
          </div>
        </div>
      </main>

      <AddEditUser
        open={open}
        setOpen={setOpen}
        setActionButton={setActionButton}
        actionButton={actionButton}
        editData={editData}
        handleClose={() => {
          setTimeout(() => {
            if (document.getElementById(selectedEditId)) {
              document.getElementById(selectedEditId).focus();
            }
          }, 200);
        }}
      />

      <DeleteModal
        setOpenDeleteModal={setOpenDeleteModal}
        openDeleteModal={openDeleteModal}
        handleDelete={() => handleDeleteUser(dispatch, deviceIdToDelete, createUserBtnRef)}
      />

      <Snackbar
        open={users.isDeleted}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={5000}
        message={"Delete Successfully."}
        onClose={() => resetDelete(dispatch)}
        className="success"
      />
    </>
  );
};

export default MangeUser;
